// extracted by mini-css-extract-plugin
export default {"userPhoto":"users_userPhoto__n2wiw"};